/** Record-level quick actions for a quotation (§19) — same universal component, handlers bound to this quote. */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { QuickActionGroup } from "@/components/quickactions/QuickActionGroup";
import { CoverMessageDialog } from "@/components/commercial/QuoteCoverMessage";
import { openWaComposer } from "@/components/whatsapp/WaComposer";

export function QuoteRecordActions({ q, onSaved }) {
  const navigate = useNavigate();
  const [cover, setCover] = useState(null);
  if (!q?.id) return null;
  const handlers = {
    duplicate: async () => { const { data } = await api.post(`/sales-desk/quotations/${q.id}/clone`); toast.success(`Duplicated as ${data?.code || "new quote"}`); onSaved?.(data); },
    reply: () => setCover("reply"),
    cover: () => setCover("copy"),
    pdf: async () => { const res = await api.get(`/vtiger/quotations/${q.id}/pdf/download`, { responseType: "blob" }); const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" })); const a = document.createElement("a"); a.href = url; a.download = `${q.code || "quotation"}.pdf`; a.click(); URL.revokeObjectURL(url); },
    whatsapp: () => openWaComposer({ record: { kind: "quotation", id: q.id, code: q.code }, purpose: "QUOTE" }),
    convert: () => navigate(`/commercial/customer-po?new=1&quote=${q.id}`),
  };
  return (
    <>
      <QuickActionGroup module="quote_record" handlers={handlers} title={`Quick actions · ${q.code || "quote"}`} compact testid="qa-quote-record" />
      {cover && <CoverMessageDialog quote={q} intent={cover} onClose={() => setCover(null)} />}
    </>
  );
}
